export const pluralHelper = (count: number): string => {
  if (count === 1) {
    return '';
  }
  return 's';
};

export const unitsHelper = (value: number, unit: string) =>
  `${value} ${unit}${pluralHelper(value)}`;

export default pluralHelper;
